import { SegmentStatistique } from "./../../models/SegmentStatistique";
import { Portefeuille } from "src/app/fonds-propres/models/Portefeuille";
import { ActivatedRoute, Params } from "@angular/router";
import { FondsPropresService } from "./../../services/fonds-propres.service";
import { PortefeuilleDetail } from "./../../models/PortefeuilleDetail";
import { Component, OnInit, AfterViewInit } from "@angular/core";

@Component({
  selector: "app-portefeuille-details",
  templateUrl: "./portefeuille-details.component.html",
  styleUrls: ["./portefeuille-details.component.scss"],
})
export class PortefeuilleDetailsComponent implements OnInit, AfterViewInit {
  isLoadingResults = false;
  portefeuilleDetails: PortefeuilleDetail[];
  portefeuille: Portefeuille;
  portefeuilles: Portefeuille[] = [];
  selectedPortefeuille: number;

  segmentStatistiques: SegmentStatistique[];
  portefeuilleId: number;

  constructor(
    private shared: FondsPropresService,
    private _activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    /*this._activatedRoute.params.subscribe((params: Params) => {
      this.portefeuilleId = params['portefeuilleId'];      
    });*/

    this.getPortefeuilles();
  }

  ngAfterViewInit() {
    //this.getImportPortefeuilleDetails(this.importPortefeuilleId, "_", 0);
  }

  ChangeSelectedPortefeuille(selected) {
    console.log(this.selectedPortefeuille, selected);

    if (this.portefeuilles) {
      if (!this.selectedPortefeuille) {
        const maxId = this.portefeuilles.reduce(
          (max, feuille) => (feuille.id > max ? feuille.id : max),
          this.portefeuilles[0].id
        );
        this.portefeuilleId = maxId;
      } else {
        this.portefeuilleId = this.selectedPortefeuille;
      }

      this.getPortefeuille(this.portefeuilleId);
      this.getPortefeuilleSegmentStatistique(this.portefeuilleId);
    }
  }

  getPortefeuille(portefeuilleId: number) {
    this.shared.getPortefeuille(portefeuilleId).subscribe(
      (data) => {
        this.portefeuille = data;
      },
      (error) => {
        console.log(error);
      },
      () => {}
    );
  }

  getPortefeuilles() {
    this.shared.getPortefeuilles().subscribe(
      (data) => {
        this.portefeuilles = data;
      },
      (error) => {
        console.log(error);
      },
      () => {
        if (this.portefeuilles == null) {
          this.portefeuilles = [];
        }
        if (this.portefeuilles) {
          const maxId = this.portefeuilles.reduce(
            (max, feuille) => (feuille.id > max ? feuille.id : max),
            this.portefeuilles[0].id
          );
          this.portefeuilleId = maxId;

          this.getPortefeuille(this.portefeuilleId);
          //this.getPortefeuilleDetails(this.portefeuilleId);
          this.getPortefeuilleSegmentStatistique(this.portefeuilleId);
        }
      }
    );
  }

  /*
  getPortefeuilleDetails(portefeuilleId: number) {
    this.shared.getPortefeuilleDetails(portefeuilleId).subscribe(
      data => { 
        this.portefeuilleDetails = data;
      },
      error => { 
        console.log("error", error);
        this.isLoadingResults = false;
       },
      () => {
          if(this.portefeuilleDetails == null) {
            this.portefeuilleDetails = [];
          }
          this.isLoadingResults = false;
      }
    );
    
  }
  */

  getPortefeuilleSegmentStatistique(portefeuilleId: number) {
    this.isLoadingResults = true;
    this.shared.getPortefeuilleSegmentStatistique(portefeuilleId).subscribe(
      (data) => {
        this.segmentStatistiques = data;
      },
      (error) => {
        console.log("error", error);
        this.isLoadingResults = false;
      },
      () => {
        if (this.segmentStatistiques == null) {
          this.segmentStatistiques = [];
        }
        this.isLoadingResults = false;
      }
    );
  }
}
